import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
import SearchPanel from "../Search/SearchPanel";

//User defiend Modules
import Common from "../../Common/Common";
import {
  randstr,
  getSessionValue,
  populateFormDetails,
} from "../../Common/Appcommon";
import FormHeader from "../../Common/FormHeader";
import requestApi from "../../services/requestApi.service";

const ViewBuilder = (props) => {
  let form =
    props.match === undefined || props.match.params.form === undefined
      ? ""
      : props.match.params.form;
  let templateId =
    props.match === undefined || props.match.params.id === undefined
      ? ""
      : props.match.params.id;

  const [showLoader, setShowLoader] = useState(false);
  const [fieldDetails, setFieldDetails] = useState([]);
  const [templateInfo, setTemplateInfo] = useState([]);
  let formDetail = [];
  let formName = getSessionValue("leadformname");

  useEffect(() => {
    (async () => {
      setShowLoader(true);
      formDetail = await populateFormDetails(formName);
      setFieldDetails(formDetail[1]);
      setTemplateInfo(await getTemplateInfo(templateId));
      if (templateInfo.length > 0) {
        await findTemplateByID(templateId);
      }
      setShowLoader(false);
    })();
    return () => {};
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  const handleClickOutside = (event) => {
    //console.log("handleClickOutside Invoked:");
  };

  const getTemplateInfo = async (Id) => {
    let template = [];
    if (formDetail.length > 0) {
      let tmpDetails = formDetail[4];
      for (let tempId in tmpDetails) {
        if (tmpDetails[tempId][0] == Id) {
          template = tmpDetails[tempId];
          break;
        }
      }
    }
    return template;
  };

  const findTemplateByID = async () => {
    let formInfo = formDetail[0];
    let moduleName = formInfo[0];
    let params = {
      ENTITY: "Save as Template",
      OPERATION: "FIND",
      FORMNAME: formName,
      MODULENAME: moduleName,
      FORMTYPE: "",
      "Template name": templateInfo[1],
      "Template Id": templateInfo[0],
      NUMBEROFROW: 50,
    };
    let formreponse = await requestApi.processServerRequest(params, "WebV2");
  };

  const searchClickCB = async (callback) => {};
  return (
    <Common
      pageTitle={"Viewbuilder"}
      mainContent={
        <div class="viewbuilder">
          {!showLoader &&
            fieldDetails.length > 0 &&
            templateInfo.length > 0 && (
              <div class="searchContainer">
                <span class="header">Criteria</span>
                <SearchPanel
                  fieldDetails={fieldDetails}
                  onSearchClickRegister={searchClickCB}
                  filterType={"form"}
                />
              </div>
            )}
          {!showLoader &&
            (fieldDetails.length == 0 || templateInfo.length == 0) && (
              <div>No Record Found</div>
            )}
        </div>
      }
      showLoader={showLoader}
    />
  );
};

export default ViewBuilder;
